"use strict";
// Functions for handling 2fa flows via OTP
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseState = void 0;
exports.Generate = Generate;
exports.AuthUserPassword = AuthUserPassword;
exports.ResendOTP = ResendOTP;
exports.AuthUserOTP = AuthUserOTP;
var auth_metadata_1 = require("./auth-metadata");
var response_1 = require("@ca/wrap-sdk/src/response");
var aws_cognito_1 = require("@ca/wrap-sdk/src/aws-cognito");
var time_1 = require("@ca/time");
var otp_email_1 = require("./otp-email");
var user_events_1 = require("@ca/user-events");
var wlf_item_1 = require("../wlf-item");
var user_event_table_1 = require("../user-event-table");
var MAX_LOGIN_FAILURES = 10;
var MAX_OTP_FAILURES = 5;
var NUM_OTP_DIGITS = 6;
var MAX_OTP_GENERATED = 2;
var SOURCE = __filename;
var ResponseState;
(function (ResponseState) {
    ResponseState["USERNAME_DOES_NOT_EXIST"] = "USERNAME_DOES_NOT_EXIST";
    ResponseState["TOO_MANY_ATTEMPTS"] = "TOO_MANY_ATTEMPTS";
    ResponseState["PASSWORD_SUCCESS"] = "PASSWORD_SUCCESS";
    ResponseState["PASSWORD_FAIL"] = "PASSWORD_FAIL";
    ResponseState["FIRST_OTP_SENT"] = "FIRST_OTP_SENT";
    ResponseState["SECOND_OTP_SENT"] = "SECOND_OTP_SENT";
    ResponseState["TOO_MANY_OTP_SENT"] = "TOO_MANY_OTP_SENT";
    ResponseState["OTP_FAIL"] = "OTP_FAIL";
    ResponseState["OTP_EXPIRE"] = "OTP_EXPIRE";
    ResponseState["TOO_MANY_OTP_FAIL"] = "TOO_MANY_OTP_FAIL";
    ResponseState["NO_PASSWORD"] = "NO_PASSWORD";
    ResponseState["NEW_PASSWORD_REQUIRED"] = "NEW_PASSWORD_REQUIRED";
    ResponseState["SUCCESS"] = "SUCCESS";
})(ResponseState || (exports.ResponseState = ResponseState = {}));
// From https://stackoverflow.com/questions/21816595/how-to-generate-a-random-number-of-fixed-length-using-javascript
function Generate(n) {
    var add = 1;
    var max = 12 - add;
    if (n > max) {
        return Generate(max) + Generate(n - max);
    }
    max = Math.pow(10, n + add);
    var min = max / 10; // Math.pow(10, n) basically
    var number = Math.floor(Math.random() * (max - min + 1)) + min;
    return ("" + number).substring(add);
}
function GenerateOTP() {
    return {
        otp: Generate(NUM_OTP_DIGITS),
        timestamp_sec: (0, time_1.get_now_sec)(),
    };
}
function AuthUserPassword(creds, username, password) {
    return __awaiter(this, void 0, void 0, function () {
        var c_resp, wl_resp, no_two_fa_auth, a_resp, auth_metadata, resp_1, resp, p_resp_1, p_resp_2, otp, e_resp, w_resp_1, w_resp, p_resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, aws_cognito_1.AdminGetUserC)(creds, username)];
                case 1:
                    c_resp = _a.sent();
                    if (c_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.SuccessResponse)({
                                response: ResponseState.USERNAME_DOES_NOT_EXIST,
                                state: auth_metadata_1.AuthState.START,
                            })];
                    }
                    return [4 /*yield*/, (0, wlf_item_1.GetWlfItemC)(creds, c_resp.payload.wlf_id)];
                case 2:
                    wl_resp = _a.sent();
                    if (wl_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, wl_resp];
                    }
                    no_two_fa_auth = !!wl_resp.payload.no_2fa_auth;
                    return [4 /*yield*/, (0, auth_metadata_1.GetAuthMetadata)(creds, username)];
                case 3:
                    a_resp = _a.sent();
                    if (a_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(a_resp)];
                    }
                    auth_metadata = a_resp.payload;
                    if (!(auth_metadata.failed_login_sec.length >= MAX_LOGIN_FAILURES)) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, user_events_1.PostLoginPasswordFail)(creds, SOURCE, username, auth_metadata.failed_login_sec.length, (0, user_event_table_1.GetUserEventTable)())];
                case 4:
                    resp_1 = _a.sent();
                    if (resp_1.status === response_1.Status.ERROR) {
                        console.log("Post Error", resp_1);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.TOO_MANY_ATTEMPTS,
                            state: auth_metadata.state,
                        })];
                case 5: return [4 /*yield*/, (0, aws_cognito_1.AuthUser)(creds, username, password)];
                case 6:
                    resp = _a.sent();
                    if (!(resp.status === response_1.Status.OK)) return [3 /*break*/, 12];
                    if (!(resp.payload.ChallengeName === "NEW_PASSWORD_REQUIRED")) return [3 /*break*/, 8];
                    return [4 /*yield*/, (0, user_events_1.PostLoginTokenSuccess)(creds, SOURCE, username, (0, user_event_table_1.GetUserEventTable)())];
                case 7:
                    p_resp_1 = _a.sent();
                    if (p_resp_1.status === response_1.Status.ERROR) {
                        console.log(p_resp_1);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.NEW_PASSWORD_REQUIRED,
                            session: resp.payload.Session,
                        })];
                case 8: return [4 /*yield*/, (0, user_events_1.PostLoginPasswordSuccess)(creds, SOURCE, username, (0, user_event_table_1.GetUserEventTable)())];
                case 9:
                    p_resp_2 = _a.sent();
                    if (p_resp_2.status === response_1.Status.ERROR) {
                        console.log("PostError", p_resp_2);
                    }
                    if (no_two_fa_auth) {
                        // Just return success, no OTP
                        return [2 /*return*/, (0, response_1.SuccessResponse)({
                                response: ResponseState.SUCCESS,
                                state: auth_metadata_1.AuthState.LOGIN_SUCCESS,
                                token: resp.payload.AuthenticationResult.IdToken,
                                refresh_token: resp.payload.AuthenticationResult.RefreshToken
                            })];
                    }
                    // Password worked
                    auth_metadata.token_timestamp_sec = (0, time_1.get_now_sec)();
                    auth_metadata.id_token = resp.payload.AuthenticationResult.IdToken;
                    auth_metadata.refresh_token = resp.payload.AuthenticationResult.RefreshToken;
                    auth_metadata.state = auth_metadata_1.AuthState.OTP;
                    otp = GenerateOTP();
                    return [4 /*yield*/, (0, otp_email_1.SendOTPEmailC)(creds, username, otp.otp)];
                case 10:
                    e_resp = _a.sent();
                    if (e_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, e_resp];
                    }
                    auth_metadata.OTP = [otp];
                    return [4 /*yield*/, (0, auth_metadata_1.WriteAuthMetadata)(creds, auth_metadata)];
                case 11:
                    w_resp_1 = _a.sent();
                    if (w_resp_1.status === response_1.Status.ERROR) {
                        return [2 /*return*/, w_resp_1];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.PASSWORD_SUCCESS,
                            state: auth_metadata.state,
                        })];
                case 12:
                    // Fail
                    auth_metadata.failed_login_sec.push((0, time_1.get_now_sec)());
                    return [4 /*yield*/, (0, auth_metadata_1.WriteAuthMetadata)(creds, auth_metadata)];
                case 13:
                    w_resp = _a.sent();
                    if (w_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, w_resp];
                    }
                    return [4 /*yield*/, (0, user_events_1.PostLoginPasswordFail)(creds, SOURCE, username, auth_metadata.failed_login_sec.length, (0, user_event_table_1.GetUserEventTable)())];
                case 14:
                    p_resp = _a.sent();
                    if (p_resp.status === response_1.Status.ERROR) {
                        console.log("PostError", p_resp);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.PASSWORD_FAIL,
                            state: auth_metadata.state,
                        })];
            }
        });
    });
}
function ResendOTP(creds, username) {
    return __awaiter(this, void 0, void 0, function () {
        var a_resp, auth_metadata, otp, e_resp, w_resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, auth_metadata_1.GetAuthMetadata)(creds, username)];
                case 1:
                    a_resp = _a.sent();
                    if (a_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(a_resp)];
                    }
                    auth_metadata = a_resp.payload;
                    // No password. Need to authenticate password first.
                    if (auth_metadata.state === auth_metadata_1.AuthState.START) {
                        return [2 /*return*/, (0, response_1.SuccessResponse)({
                                response: ResponseState.NO_PASSWORD,
                                state: auth_metadata.state,
                            })];
                    }
                    // Too many OTPs have been generated.
                    if (auth_metadata.OTP.length >= MAX_OTP_GENERATED) {
                        return [2 /*return*/, (0, response_1.SuccessResponse)({
                                response: ResponseState.TOO_MANY_OTP_SENT,
                                state: auth_metadata.state,
                            })];
                    }
                    otp = GenerateOTP();
                    return [4 /*yield*/, (0, otp_email_1.SendOTPEmailC)(creds, username, otp.otp)];
                case 2:
                    e_resp = _a.sent();
                    if (e_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, e_resp];
                    }
                    auth_metadata.OTP.push(otp);
                    auth_metadata.state = auth_metadata_1.AuthState.OTP_2;
                    return [4 /*yield*/, (0, auth_metadata_1.WriteAuthMetadata)(creds, auth_metadata)];
                case 3:
                    w_resp = _a.sent();
                    if (w_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, w_resp];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.SECOND_OTP_SENT,
                            state: auth_metadata.state,
                        })];
            }
        });
    });
}
function AuthUserOTP(creds, username, otp) {
    return __awaiter(this, void 0, void 0, function () {
        var a_resp, auth_metadata, resp_2, resp_3, resp_4, r_1, r_2, w_resp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, auth_metadata_1.GetAuthMetadata)(creds, username)];
                case 1:
                    a_resp = _a.sent();
                    if (a_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(a_resp)];
                    }
                    auth_metadata = a_resp.payload;
                    if (!(auth_metadata.OTP.length === 0)) return [3 /*break*/, 3];
                    // Expired OTP, return to START state
                    auth_metadata.state = auth_metadata_1.AuthState.START;
                    auth_metadata.token_timestamp_sec = undefined;
                    auth_metadata.id_token = undefined;
                    auth_metadata.refresh_token = undefined;
                    return [4 /*yield*/, (0, auth_metadata_1.WriteAuthMetadata)(creds, auth_metadata)];
                case 2:
                    resp_2 = _a.sent();
                    if (resp_2.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp_2];
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.OTP_EXPIRE,
                            state: auth_metadata.state,
                        })];
                case 3:
                    if (!(auth_metadata.otp_fail >= MAX_OTP_FAILURES)) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, user_events_1.PostLoginOTPFail)(creds, SOURCE, username, auth_metadata.otp_fail, (0, user_event_table_1.GetUserEventTable)())];
                case 4:
                    resp_3 = _a.sent();
                    if (resp_3.status === response_1.Status.ERROR) {
                        console.log("PostError", resp_3);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.TOO_MANY_OTP_FAIL,
                            state: auth_metadata.state,
                        })];
                case 5:
                    if (!(auth_metadata.OTP[auth_metadata.OTP.length - 1].otp === otp)) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, auth_metadata_1.RemoveAuthMetadata)(creds, username)];
                case 6:
                    resp_4 = _a.sent();
                    if (resp_4.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp_4];
                    }
                    return [4 /*yield*/, (0, user_events_1.PostLoginOTPSuccess)(creds, SOURCE, username, (0, user_event_table_1.GetUserEventTable)())];
                case 7:
                    r_1 = _a.sent();
                    return [4 /*yield*/, (0, user_events_1.PostLogin2FASuccess)(creds, SOURCE, username, (0, user_event_table_1.GetUserEventTable)())];
                case 8:
                    r_2 = _a.sent();
                    if (r_1.status === response_1.Status.ERROR) {
                        console.log("PostError", r_1);
                    }
                    if (r_2.status === response_1.Status.ERROR) {
                        console.log("PostError", r_2);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.SUCCESS,
                            state: auth_metadata_1.AuthState.LOGIN_SUCCESS,
                            token: auth_metadata.id_token,
                            refresh_token: auth_metadata.refresh_token,
                        })];
                case 9:
                    // failed
                    auth_metadata.otp_fail++;
                    return [4 /*yield*/, (0, auth_metadata_1.WriteAuthMetadata)(creds, auth_metadata)];
                case 10:
                    w_resp = _a.sent();
                    if (w_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, w_resp];
                    }
                    return [4 /*yield*/, (0, user_events_1.PostLoginOTPFail)(creds, SOURCE, username, auth_metadata.otp_fail, (0, user_event_table_1.GetUserEventTable)())];
                case 11:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        console.log("PostError 2", resp);
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)({
                            response: ResponseState.OTP_FAIL,
                            state: auth_metadata.state,
                        })];
            }
        });
    });
}
//# sourceMappingURL=two-factor-authentication.js.map